import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {withStyles, Button} from '@material-ui/core';
import {compose} from 'recompose';
import {withTranslation} from 'react-i18next';
import ButtonAtm from '../../../../../atomic/Button/Button';
import {getProfile} from '../../../../../../redux/actions/User/Profile/profileAction';

const ALLOWED_EMAILS = [
    'cemile@extranetwork.com',
    'bulut@extranetwork.com',
    'yoy@extranetwork.com',
    'onur@extranetwork.com',
    'cem@extranetwork.com',
    'partnerships@extranetwork.com'
];

const c = {
    red: '#d71f26',
    text: '#334155',
    sub: '#64748b',
    line: '#e2e8f0',
};

const titleStyles = theme => ({
    root: {margin: 0, padding: theme.spacing(2, 3)},
    closeButton: {position: 'absolute', right: theme.spacing(1.5), top: theme.spacing(1.5), color: theme.palette.grey[500]},
});

const DialogTitle = withStyles(titleStyles)(props => {
    const {children, classes, onClose, ...other} = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6" style={{fontWeight: 700}}>{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon className="close-button"/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {padding: theme.spacing(3), background: '#fbfcfe'},
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {margin: 0, padding: theme.spacing(2, 3), borderTop: `1px solid ${c.line}`},
}))(MuiDialogActions);

// className / fullwidth / startIcon disaridan verilebilir; verilmezse dashboard'daki
// tam genislikteki buton gorunumu korunur (Ayarlar sayfasi kendi olcusunu geciyor).
function UnpublishWebButton({t, domain, userEmail, getProfile, onConfirm, className, fullwidth, startIcon}) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!userEmail && typeof getProfile === 'function') {
            getProfile();
        }
    }, [userEmail, getProfile]);

    const handleOpen = () => setOpen(true);

    const handleClose = () => setOpen(false);

    const handleConfirm = () => {
        setOpen(false);
        if (typeof onConfirm === 'function') {
            onConfirm();
        }
    };

    // Yetki: sadece allowlist'teki e-postalar butonu görür
    if (!userEmail || !ALLOWED_EMAILS.includes(userEmail.toLowerCase())) {
        return null;
    }

    return (
        <>
            <ButtonAtm
                className={className || 'site-unpublish-btn'}
                fullwidth={fullwidth === undefined ? true : fullwidth}
                startIcon={startIcon}
                buttontext={t('btn-unpublish', 'Yayından Kaldır')}
                value={domain && domain.id}
                onClick={handleOpen}
            />

            <Dialog
                onClose={handleClose}
                open={open}
                maxWidth="sm"
                fullWidth
                disableBackdropClick={true}
                aria-labelledby="unpublish-web-title"
            >
                <DialogTitle className="red-bottom-border" id="unpublish-web-title" onClose={handleClose}>
                    {t('enw-web-unpublish-title', 'Siteyi Yayından Kaldır')}
                </DialogTitle>

                <DialogContent>
                    <div style={{
                        display: 'flex', gap: 10, alignItems: 'flex-start',
                        background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10,
                        padding: '12px 14px', marginBottom: 20,
                    }}>
                        <i className="fas fa-exclamation-triangle" style={{color: c.red, marginTop: 2}}/>
                        <span style={{fontSize: 13, color: c.text, lineHeight: 1.5}}>
                            {t('enw-web-unpublish-confirm-desc', 'Siteniz yayından kaldırılacak ve ziyaretçiler tarafından erişilemeyecek. Daha sonra "Yayınla" butonu ile tekrar yayına alabilirsiniz; bu işlemde DNS ve SSL doğrulaması yeniden yapılır.')}
                        </span>
                    </div>

                    {domain && domain.domain && (
                        <div style={{
                            border: `1px solid ${c.line}`, borderRadius: 12, padding: '12px 16px',
                            background: '#fff', display: 'flex', flexDirection: 'column', gap: 6,
                        }}>
                            <span style={{
                                fontSize: 11, fontWeight: 700, letterSpacing: '.04em',
                                textTransform: 'uppercase', color: '#9ca3af',
                            }}>
                                {t('enw-myw-domain_title')}
                            </span>
                            <span style={{fontWeight: 700, color: c.text, fontSize: 15, wordBreak: 'break-all'}}>
                                {domain.domain}
                            </span>
                        </div>
                    )}

                    <p style={{fontSize: 13, color: c.sub, marginTop: 20, marginBottom: 0}}>
                        {t('enw-web-unpublish-confirm-question', 'Devam etmek istediğinize emin misiniz?')}
                    </p>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} style={{textTransform: 'none', fontWeight: 600, height: 42}}>
                        {t('btn-cancel', 'Vazgeç')}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleConfirm}
                        startIcon={<i className="fas fa-power-off"/>}
                        style={{
                            height: 44, minWidth: 180, textTransform: 'none', fontWeight: 700,
                            borderRadius: 10, boxShadow: 'none',
                            backgroundColor: c.red,
                            color: '#fff',
                        }}
                    >
                        {t('btn-unpublish', 'Yayından Kaldır')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

const mapStateToProps = (state) => ({
    userEmail: state.profileReducer && state.profileReducer.profileData
        && state.profileReducer.profileData.profile
        && state.profileReducer.profileData.profile.email,
});

const mapDispatchToProps = {
    getProfile,
};

export default compose(
    withTranslation('common'),
    connect(mapStateToProps, mapDispatchToProps)
)(UnpublishWebButton);
